<template>
  <div class="digital-realtime-alarm-page">
    <div class="chart-block">
      <!-- <img src="/static/images/digitalarea/ssbj.png" class="titl"> -->
      <div class="table-data">
        <table>
          <thead>
            <tr>
              <!-- <th>报警类型</th> -->
              <th>报警位置</th>
              <th>报警描述</th>
              <th>报警时间</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in itemList" :key="item.Station" class="alarm-type-2">
              <!-- <td><span v-text="item.StatusFlag"></span></td> -->
              <td><span v-text="item.Station"></span></td>
              <td :title="item.desc"><span v-text="item.AlarmTag" class="tdtxt"></span></td>
              <td><span v-text="$formatDateTime((new Date(item.StartTime)).getTime()/1000, 'yy/MM/dd hh:mm')"></span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  props: ['theme'],
  data() {
    return {
      itemList: [],
    }
  },
  mounted() {
    let self = this;
    setInterval(function() {self.resetData();}, 20000);  //20秒执行
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    //初始化
    this.$initPage(this);
  },
  methods: {
    resetData() {
      //实时报警
      setInterval(this.getItemList(),30*1000)
      //this.getItemList();
    },
    getItemList() {
      let self = this;
      let status = 1;  //状态
      let url = '/InteractAPI/GetAlarmStatus_status_Json/'+status;
      this.$handleRequest(window.ApiHost2+url, {}, 'get', function(res) {  //success
        self.itemList = res;
      }, function(res) {  //fail
        console.log('fail', res);
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/xiayan/digitalarea/RealtimeAlarm.vue